const MINUTE = 60_000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

/**
 * TCR-1963 — nhãn đồng hồ tự huỷ đơn Nháp. Độ phân giải phút (ticket: không cần
 * chính xác tới giây). `urgent` = còn dưới 1 ngày hoặc đã quá hạn → tô đỏ.
 */
export function formatDraftCountdown(
  expiresAt: string | Date | null | undefined,
  now: Date,
): { text: string; urgent: boolean } | null {
  if (!expiresAt) return null;
  const end = new Date(expiresAt).getTime();
  if (Number.isNaN(end)) return null;
  const left = end - now.getTime();
  if (left <= 0) return { text: 'Đang chờ tự huỷ', urgent: true };

  const totalMinutes = Math.ceil(left / MINUTE);
  const days = Math.floor(totalMinutes / (24 * 60));
  const hours = Math.floor((totalMinutes % (24 * 60)) / 60);
  const minutes = totalMinutes % 60;

  const parts: string[] = [];
  if (days > 0) {
    parts.push(`${days} ngày`);
    if (hours > 0) parts.push(`${hours} giờ`);
  } else {
    if (hours > 0) parts.push(`${hours} giờ`);
    if (minutes > 0) parts.push(`${minutes} phút`);
  }
  return { text: `Còn ${parts.join(' ')} trước khi tự huỷ`, urgent: left < DAY };
}
